module.exports = __webpack_public_path__ + "static/media/about-us.0eff2ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-us.jpg
// module id = 486
// module chunks = 33